<template>
  <div class="Content">
    
    <div class="helpContent featured_article">
        
        <div id="contact-form" class="contact-form">
            
            <form class="form" style="font-size:1.5rem">
                
                <p class="title">Thank you for your feedback. Part 2 of The Award is now unlocked and you are ready to go</p>
                <span class="question button" v-on:click="home">Home page</span>
            </form>
        </div>
    </div>
</div>

</template>

<script>
export default {
  methods: {
    home: function (e) {
      this.$router.push('/home');
    }
  },
}
</script>

<style>

</style>